<template>
  <SearchBarProvider
    :module-name="moduleName"
    :prevent-api="onlyKeywords"
    :prevent-supported-api="preventSupportedApi"
    :sub-module-name="subModuleName"
    :credential-profile-type="credentialProfileType"
    :is-requester="isRequester"
  >
    <Search
      ref="searchRef"
      v-bind="$attrs"
      :module-name="moduleName"
      :only-keywords="onlyKeywords"
      :credential-profile-type="credentialProfileType"
      :is-requester="isRequester"
      v-on="listeners"
      @change="$emit('change', $event)"
    />
  </SearchBarProvider>
</template>

<script>
import SearchBarProvider from './search-bar-provider'
import Search from './search'
export default {
  name: 'FlotoSearchBar',
  components: { SearchBarProvider, Search },
  inheritAttrs: false,
  model: {
    event: 'change',
  },
  props: {
    moduleName: { type: String, required: true },
    onlyKeywords: { type: Boolean, default: false },
    preventSupportedApi: { type: Boolean, default: false },
    subModuleName: { type: String, default: undefined },
    credentialProfileType: { type: String, default: 'agent' },
    isRequester: { type: Boolean, default: false },
  },
  computed: {
    listeners() {
      const { change, ...listeners } = this.$listeners
      return listeners
    },
  },
  methods: {
    addKeyword(k) {
      this.$refs.searchRef.addKeyword(k)
    },
  },
}
</script>
